import React from 'react';

const MobileCallButton = () => {
    return (
        <a
            href="tel:+420734312843"
            aria-label="Zavolat na +420 734 312 843"
            className="sm:hidden fixed bottom-5 right-5 z-30 inline-flex items-center gap-2 pl-4 pr-5 py-3.5 rounded-full bg-brand-500 text-white font-semibold shadow-brand-glow hover:bg-brand-600 active:scale-95 transition-all duration-200 ease-smooth"
        >
            <span className="relative flex h-8 w-8 items-center justify-center">
                <span className="absolute inline-flex h-full w-full rounded-full bg-white/30 animate-ping" />
                <svg className="relative w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92z" />
                </svg>
            </span>
            Zavolat
        </a>
    );
};

export default MobileCallButton;
